export default __webpack_public_path__ + "static/media/hht1_direction_word_play_02.7083f5c4.jpg";